import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  textArea: {
    width: '100%',
    resize: 'none',
    border: `1px solid ${theme.palette.gray.efesBorder}`,
    padding: 5,

    '& div': {
      '& fieldset': {
        border: 'unset',
      },
      '&::before': {
        content: 'none',
      },
      '&::after': {
        content: 'none',
      },
    },
  },
}));

export default useStyles;
